var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'border border-gray-300': !_vm.borderLess
  }},[_c('div',{staticClass:"flex flex-col justify-center items-center"},[_c('div',{ref:"qrcode",staticClass:"py-2 qrcode-item"}),_c('h3',{staticClass:"font-semibold text-blueGray-500 text-md -mt-2"})])])}
var staticRenderFns = []

export { render, staticRenderFns }